import { render } from "./TeamProjects.vue?vue&type=template&id=5736b917&scoped=true&ts=true"
import script from "./TeamProjects.vue?vue&type=script&lang=ts"
export * from "./TeamProjects.vue?vue&type=script&lang=ts"

import "./TeamProjects.vue?vue&type=style&index=0&id=5736b917&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5736b917"]])

export default __exports__